// import React, { useState } from 'react';
// import {
//     Box, Container, Heading, Button,
//     Input, Textarea, FormControl, FormLabel,
//     VStack, useToast, Select, Text
// } from '@chakra-ui/react';
// import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
// import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
// import { db, storage } from '../../firebase';
// import { v4 as uuidv4 } from 'uuid';

// const AddPost = () => {
//     const [formData, setFormData] = useState({
//         title: '',
//         content: '',
//         category: 'General',
//         image: null
//     });
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const toast = useToast();

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     const handleImageChange = (e) => {
//         if (e.target.files[0]) {
//             setFormData(prev => ({ ...prev, image: e.target.files[0] }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!formData.image) {
//             toast({
//                 title: 'Error',
//                 description: 'Please select an image',
//                 status: 'error',
//                 duration: 3000,
//             });
//             return;
//         }

//         setLoading(true);
//         setUploadProgress(0);

//         try {
//             // 1. Generate unique filename
//             const fileExtension = formData.image.name.split('.').pop();
//             const fileName = `${uuidv4()}.${fileExtension}`;

//             // 2. Create storage reference
//             const storageRef = ref(storage, `blog-images/${fileName}`);

//             console.log('Uploading file:', fileName);
//             console.log('File size:', formData.image.size);
//             console.log('File type:', formData.image.type);
//             console.log('Storage reference:', storageRef.fullPath);

//             // 3. Upload file with metadata
//             const uploadTask = uploadBytesResumable(storageRef, formData.image, {
//                 contentType: formData.image.type,
//                 customMetadata: {
//                     uploadedBy: 'admin' // Replace with actual user if authenticated
//                 }

//             });
//             console.log('Upload task created:', uploadTask);
//             console.log('Upload task snapshot:', uploadTask.snapshot);
//             console.log('Upload task state:', uploadTask.snapshot.state);
//             console.log('Upload task error:', uploadTask.snapshot.error);

//             // 4. Track upload progress
//             uploadTask.on('state_changed',
//                 (snapshot) => {
//                     const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//                     setUploadProgress(progress);
//                     console.log(`Upload is ${progress}% done`);
//                     switch (snapshot.state) {
//                         case 'paused':
//                             console.log('Upload is paused');
//                             break;
//                         case 'running':
//                             console.log('Upload is running');
//                             break;
//                         default:
//                             console.log('Unknown state');
//                     }
//                 },
//                 (error) => {
//                     console.error('Upload error:', error);
//                     toast({
//                         title: 'Upload failed',
//                         description: error.message,
//                         status: 'error',
//                         duration: 3000,
//                     });
//                     setLoading(false);
//                 },
//                 async () => {
//                     try {
//                         // 5. Get download URL after successful upload
//                         const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

//                         // 6. Save post data to Firestore
//                         await addDoc(collection(db, 'posts'), {
//                             title: formData.title,
//                             content: formData.content,
//                             category: formData.category,
//                             imageUrl: downloadURL,
//                             createdAt: serverTimestamp(),
//                             updatedAt: serverTimestamp(),
//                             author: "Admin",
//                             tags: [],
//                             fileName: fileName // Store the filename for future reference
//                         });

//                         toast({
//                             title: 'Post published!',
//                             status: 'success',
//                             duration: 3000,
//                         });

//                         // 7. Reset form
//                         setFormData({
//                             title: '',
//                             content: '',
//                             category: 'General',
//                             image: null
//                         });
//                         setUploadProgress(0);
//                     } catch (error) {
//                         console.error('Firestore error:', error);
//                         toast({
//                             title: 'Error saving post',
//                             description: error.message,
//                             status: 'error',
//                             duration: 3000,
//                         });
//                     } finally {
//                         setLoading(false);
//                     }
//                 }
//             );
//         } catch (error) {
//             console.error('General error:', error);
//             toast({
//                 title: 'Error',
//                 description: 'An unexpected error occurred',
//                 status: 'error',
//                 duration: 3000,
//             });
//             setLoading(false);
//         }
//     };

//     return (
//         <Container maxW="container.md" py={8}>
//             <Heading mb={6}>Add New Blog Post</Heading>
//             <Box as="form" onSubmit={handleSubmit}>
//                 <VStack spacing={6}>
//                     <FormControl isRequired>
//                         <FormLabel>Title</FormLabel>
//                         <Input
//                             name="title"
//                             value={formData.title}
//                             onChange={handleChange}
//                         />
//                     </FormControl>

//                     <FormControl isRequired>
//                         <FormLabel>Content</FormLabel>
//                         <Textarea
//                             name="content"
//                             value={formData.content}
//                             onChange={handleChange}
//                             minH="200px"
//                         />
//                     </FormControl>

//                     <FormControl isRequired>
//                         <FormLabel>Category</FormLabel>
//                         <Select
//                             name="category"
//                             value={formData.category}
//                             onChange={handleChange}
//                         >
//                             <option value="General">General</option>
//                             <option value="Technology">Technology</option>
//                             <option value="Design">Design</option>
//                             <option value="Business">Business</option>
//                         </Select>
//                     </FormControl>

//                     <FormControl isRequired>
//                         <FormLabel>Featured Image</FormLabel>
//                         <Input
//                             type="file"
//                             accept="image/*"
//                             onChange={handleImageChange}
//                         />
//                         {uploadProgress > 0 && uploadProgress < 100 && (
//                             <Box mt={2}>
//                                 <Text>Uploading: {Math.round(uploadProgress)}%</Text>
//                             </Box>
//                         )}
//                     </FormControl>

//                     <Button
//                         type="submit"
//                         colorScheme="blue"
//                         isLoading={loading}
//                         loadingText={uploadProgress > 0 ? `Uploading (${Math.round(uploadProgress)}%)` : 'Publishing...'}
//                         w="full"
//                     >
//                         Publish Post
//                     </Button>
//                 </VStack>
//             </Box>
//         </Container>
//     );
// };

// export default AddPost;

import React, { useState } from 'react';
import {
  Box, Container, Heading, Button,
  Input, Textarea, FormControl, FormLabel,
  VStack, useToast, Select, Text
} from '@chakra-ui/react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase'; // We'll only use Firestore now
import { v4 as uuidv4 } from 'uuid';

const AddPost = () => {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    category: 'General',
    image: null
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setFormData(prev => ({ ...prev, image: e.target.files[0] }));
    }
  };

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'DremotechStorage'); // Replace with your preset
    formData.append('cloud_name', 'dj6eghdzu'); // Replace with your cloud name

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/dj6eghdzu/image/upload`, // Replace with your cloud name
        {
          method: 'POST',
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error('Upload failed');
      }

      return await response.json();
    } catch (error) {
      console.error('Cloudinary upload error:', error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.image) {
      toast({
        title: 'Error',
        description: 'Please select an image',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    setLoading(true);
    setUploadProgress(0);

    try {
      // 1. Upload image to Cloudinary
      const cloudinaryResponse = await uploadToCloudinary(formData.image);
      const imageUrl = cloudinaryResponse.secure_url;

      // 2. Save post data to Firestore
      await addDoc(collection(db, 'posts'), {
        title: formData.title,
        content: formData.content,
        category: formData.category,
        imageUrl: imageUrl,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        author: "Admin",
        tags: [],
        cloudinaryId: cloudinaryResponse.public_id // Store Cloudinary public ID for future reference
      });

      toast({
        title: 'Post published!',
        status: 'success',
        duration: 3000,
      });

      // 3. Reset form
      setFormData({
        title: '',
        content: '',
        category: 'General',
        image: null
      });
    } catch (error) {
      console.error('Error:', error);
      toast({
        title: 'Error',
        description: error.message || 'Failed to publish post',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  };

  return (
    <Container maxW="container.md" py={8}>
      <Heading mb={6}>Add New Blog Post</Heading>
      <Box as="form" onSubmit={handleSubmit}>
        <VStack spacing={6}>
          <FormControl isRequired>
            <FormLabel>Title</FormLabel>
            <Input
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Content</FormLabel>
            <Textarea
              name="content"
              value={formData.content}
              onChange={handleChange}
              minH="200px"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Category</FormLabel>
            <Select
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="General">General</option>
              <option value="Technology">Technology</option>
              <option value="Design">Design</option>
              <option value="Business">Business</option>
            </Select>
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Featured Image</FormLabel>
            <Input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
            />
            {uploadProgress > 0 && uploadProgress < 100 && (
              <Box mt={2}>
                <Text>Uploading: {Math.round(uploadProgress)}%</Text>
              </Box>
            )}
          </FormControl>

          <Button
            type="submit"
            colorScheme="blue"
            isLoading={loading}
            loadingText={loading ? 'Publishing...' : ''}
            w="full"
          >
            Publish Post
          </Button>
        </VStack>
      </Box>
    </Container>
  );
};

export default AddPost;